import { Group, Panel } from 'react-resizable-panels';
import { ResizablePanelHandle } from 'utils/layout/panelResize.utils';
import EarthquakeDetailsPanel from './components/EarthquakeDetailsPanel/EarthquakeDetailsPanel';
import EarthquakeList from './components/EarthquakeList/EarthquakeList';

const EarthquakeInformationPanel = ({
  earthquakes = [],
  selectedEarthquake,
  isRefreshing = false,
  isResizable = false,
  layoutVariant = 'default',
  onSelectEarthquake,
}) => {
  const isWidgetLayout = layoutVariant === 'widget';
  const details = (
    <EarthquakeDetailsPanel
      earthquake={selectedEarthquake}
      className={
        isResizable ? 'h-100 overflow-auto pe-1' : isWidgetLayout ? 'flex-shrink-0' : undefined
      }
    />
  );
  const list = (
    <EarthquakeList
      earthquakes={earthquakes}
      selectedEarthquakeId={selectedEarthquake?.id}
      isRefreshing={isRefreshing}
      onSelectEarthquake={onSelectEarthquake}
    />
  );

  if (!isResizable) {
    return (
      <div
        className={
          isWidgetLayout
            ? 'd-flex h-100 min-h-0 w-100 flex-column gap-2 overflow-hidden p-2'
            : 'd-flex min-h-0 flex-column gap-3'
        }
      >
        {details}
        {list}
      </div>
    );
  }

  return (
    <Group
      orientation="vertical"
      className="earthquakes-side-panel-group d-flex h-100 min-h-0 flex-column"
    >
      <Panel
        defaultSize="150px"
        minSize="140px"
        className="d-flex min-h-0 flex-column overflow-auto"
      >
        {details}
      </Panel>

      <ResizablePanelHandle
        aria-label="Resize earthquake details and event list"
        direction="horizontal"
      />

      <Panel minSize="180px" className="d-flex min-h-0 flex-column">
        {list}
      </Panel>
    </Group>
  );
};

export default EarthquakeInformationPanel;
